import { IconProps } from './IconProps';

export const ClockWhite = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM12 5V12L7.05029 16.9497C9.29057 19.19 12.7563 19.6463 15.5001 18.0622C18.2439 16.4781 19.5816 13.2485 18.7615 10.1882C17.9415 7.12794 15.1683 4.99997 12 5ZM3 12C3 16.9706 7.02944 21 12 21C16.9705 20.9999 20.9999 16.9705 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z"
        fill={props.fill ?? 'white'}
      />
    </svg>
  );
};

